/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Scenario content for aggregations detection
 * @export
 * @interface InternalApiScenarioContentForAggregationsDetection
 */
export interface InternalApiScenarioContentForAggregationsDetection {
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioContentForAggregationsDetection
     */
    content: string;
    /**
     * 
     * @type {InternalApiScenarioContentForAggregationsDetectionLanguageEnum}
     * @memberof InternalApiScenarioContentForAggregationsDetection
     */
    language: InternalApiScenarioContentForAggregationsDetectionLanguageEnum;
}

/**
* @export
* @enum {string}
*/
export enum InternalApiScenarioContentForAggregationsDetectionLanguageEnum {
    SQL = 'SQL',
    JMESPATH = 'JMESPATH'
}


/**
 * Check if a given object implements the InternalApiScenarioContentForAggregationsDetection interface.
 */
export function instanceOfInternalApiScenarioContentForAggregationsDetection(value: object): value is InternalApiScenarioContentForAggregationsDetection {
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('language' in value) || value['language'] === undefined) return false;
    return true;
}

export function InternalApiScenarioContentForAggregationsDetectionFromJSON(json: any): InternalApiScenarioContentForAggregationsDetection {
    return InternalApiScenarioContentForAggregationsDetectionFromJSONTyped(json, false);
}

export function InternalApiScenarioContentForAggregationsDetectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioContentForAggregationsDetection {
    if (json == null) {
        return json;
    }
    return {
        
        'content': json['content'],
        'language': json['language'],
    };
}

export function InternalApiScenarioContentForAggregationsDetectionToJSON(json: any): InternalApiScenarioContentForAggregationsDetection {
    return InternalApiScenarioContentForAggregationsDetectionToJSONTyped(json, false);
}

export function InternalApiScenarioContentForAggregationsDetectionToJSONTyped(value?: InternalApiScenarioContentForAggregationsDetection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'content': value['content'],
        'language': value['language'],
    };
}

